module.exports = __webpack_public_path__ + "img/03.73de0fa1.jpg";